module.exports = __webpack_public_path__ + "img/58_flag.01d35be1.jpg";